// extracted by mini-css-extract-plugin
export var dropdownContainer = "_lx-0";
export var leftAlign = "_lx-4";
export var listItem = "_lx-2";
export var listItemWrapper = "_lx-1";
export var operationText = "_lx-3";